import { DtoPedido } from './../dominio/DtoPedido';
import { UError } from './../../../../util/uerror';
import { CoDocumento, CoDocumentoPk } from './../../codocumento/dominio/CoDocumento';
import { DtoPersonamast } from 'src/app/erp/core/personamast/dominio/DtoPersonamast';
import { FiltroCoPedido } from './../dominio/FiltroCoPedido';
import { Injectable, Inject } from '@angular/core';
//import { Http, Headers, Response, URLSearchParams } from '@angular/http';
import { AppConfig } from 'src/environments/appconfig';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ParametroPaginacionGenerico } from 'src/app/util/ParametroPaginacionGenerico';
//import { UHttps } from '../../../../seguridad/seguridad/uhttps';
import { DtoCotizacion } from '../../cotizacion/dominio/DtoCotizacion';
import { UHttpsClient } from 'src/app/seguridad/seguridad/uhttpsClient';

@Injectable()
export class CoPedidosServicio {

    private url = `${this.config.getEnv('proxy')}spring/comercial/codocumento/`;
    private headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    constructor(private http: UHttpsClient, private config: AppConfig) { }

    public listarPedidosPaginacion(filtro: FiltroCoPedido): Promise<ParametroPaginacionGenerico> {
        return this.http.post(`${this.url}listarPedidosPaginacion`, filtro, { headers: this.headers })
            .toPromise()
            .then(response => {
                return response as ParametroPaginacionGenerico;
            })
            .catch(error => new ParametroPaginacionGenerico());
    }

    public obtenerAutorizacionDescuento04(bean: CoDocumento): Promise<CoDocumento> {
        return this.http.post(`${this.url}obtenerAutorizacionDescuento04`, bean, { headers: this.headers })
            .toPromise()
            .then(response => {
                return response as CoDocumento;
            })
            .catch(error => new CoDocumento);
    }


    public esAprobador(): Promise<DtoCotizacion> {
        return this.http.get(`${this.url}esAprobador`, { headers: this.headers })
            .toPromise()
            .then(response => {
                return response as DtoCotizacion;
            })
            .catch(error => new DtoCotizacion);
    }

    public esAdministrador(): Promise<DtoCotizacion> {
        return this.http.get(`${this.url}esAdministrador`, { headers: this.headers })
            .toPromise()
            .then(response => {
                return response as DtoCotizacion;
            })
            .catch(error => new DtoCotizacion);
    }

    public puedeVerMargen(): Promise<DtoCotizacion> {
        return this.http.get(`${this.url}puedeVerMargen`, { headers: this.headers })
            .toPromise()
            .then(response => {
                return response as DtoCotizacion;
            })
            .catch(error => new DtoCotizacion);
    }

    imprimir(filtro: FiltroCoPedido
    ): Promise<ArrayBuffer> {

        return this.http.post(`${this.url}imprimir`,
            filtro
            ,
            {
                headers: this.headers, responseType: 'blob' as 'json'
            })
            .toPromise()
            .then(response => response as ArrayBuffer)
            .catch(error => Promise.reject(error.json() as UError));
    }


    public obtenerCliente(bean: DtoPersonamast): Promise<CoDocumento> {
        return this.http.post(`${this.url}obtenerCliente`, bean, { headers: this.headers })
            .toPromise()
            .then(response => {
                return response as CoDocumento;
            })
            .catch(error => null);
    }


    public wfOpen(bean: DtoPersonamast): Promise<CoDocumento> {
        return this.http.post(`${this.url}wfopen`, bean, { headers: this.headers })
            .toPromise()
            .then(response => {
                return response as CoDocumento;
            })
            .catch(error => null);
    }


    solicitudAnular(bean: DtoPedido): Promise<any> {
        return this.http.post(`${this.url}solicitudAnularPedido`, bean, { headers: this.headers })
            .toPromise()
            .then(response => response as DtoPedido)
            .catch(error => null);
    }

    solicitudAprobarUno(bean: DtoPedido): Promise<any> {
        return this.http.post(`${this.url}validaraprobarPedidoUno`, bean, { headers: this.headers })
            .toPromise()
            .then(response => response as number)
            .catch(error => null);
    }

    solicitudDesAprobar(bean: DtoPedido): Promise<any> {
        return this.http.post(`${this.url}solicitudDesAprobarPedido`, bean, { headers: this.headers })
            .toPromise()
            .then(response => response as DtoPedido)
            .catch(error => null);
    }

    validarReject(bean: DtoPedido): Promise<any> {
        return this.http.post(`${this.url}validarReject`, bean, { headers: this.headers })
            .toPromise()
            .then(response => response as number)
            .catch(error => null);
    }

    public obtenerPorId(pk: CoDocumentoPk): Promise<CoDocumento> {
        return this.http.post(`${this.url}obtenerPorId`, pk, { headers: this.headers })
            .toPromise()
            .then(response => {
                return response as CoDocumento;
            })
            .catch(error => new CoDocumento());
    }

    public obtenerCompletoPorId(pk: CoDocumentoPk): Promise<CoDocumento> {
        return this.http.post(`${this.url}obtenerCompletoPorId`, pk, { headers: this.headers })
            .toPromise()
            .then(response => {
                return response as CoDocumento;
            })
            .catch(error => null);
    }
    public aprobarActualizarPedido(bean: CoDocumento): Promise<CoDocumento> {
        return this.http.post(`${this.url}aprobarPedido`, bean, { headers: this.headers })
            .toPromise()
            .then(response => {
                return response as CoDocumento;
            })
            .catch(error => null);
    }

}

